<div class="configuration-area">
  <configuration-area-header></configuration-area-header>
  <configuration-area-content></configuration-area-content>
</div>
